import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MediaThumbnailComponent } from '@x/common/media-thumbnail/media-thumbnail.component';
import { OperationModule } from '@x/common/operation';
import { GhostButtonComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-button/ghost-button.component';
import { MainMenuComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/menu-ui/components/main-menu/main-menu.component';
import { MyAccountMenuComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/menu-ui/components/my-account-menu/my-account-menu.component';
import { TaxonMenuComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/menu-ui/components/taxon-menu/taxon-menu.component';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { UrlModule } from '@x/ecommerce-shop/app/core/url/url.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { SearchModule } from 'apps/ecommerce-shop/src/app/core/search';
import { LoaderModule } from 'libs/common/src/loader';
import { MainMenuTreeComponent } from './components/main-menu-tree/main-menu-tree.component';

@NgModule({
  declarations: [
    MainMenuComponent,
    TaxonMenuComponent,
    MyAccountMenuComponent,
    MainMenuTreeComponent,
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    RouterModule,
    SearchModule,
    UtilsModule,
    FontAwesomeModule,
    MatListModule,
    LoaderModule,
    NeedHelpModule,
    MatButtonModule,
    MatTooltipModule,
    CdkTreeModule,
    UrlModule,
    MediaThumbnailComponent,
    OperationModule,
    GhostButtonComponent,
  ],
  exports: [
    MainMenuComponent,
    TaxonMenuComponent,
    MyAccountMenuComponent,
    MainMenuTreeComponent,
  ],
})
export class MenuUiModule {}
